<template>
  <div class="txn-page">
    <div class="txn-inner">
      <section class="txn-card" aria-label="Deposit">
        <h1 class="txn-title">
          {{
            $store.state.language === 'en'
              ? 'Deposit'
              : 'ငွေသွင်း'
          }}
        </h1>
        <div class="txn-body">
          <form @submit.prevent>
            <div class="txn-field">
              <label class="txn-label" for="deposit-account-type">{{
                $store.state.language === 'en'
                  ? 'Choose payment type'
                  : 'ငွေပေးချေမူပုံစံ ရွေးချယ်ပါ'
              }}</label>
              <AccountSelect
                :data="selected_account"
                field="account_id"
                :accounts="accounts"
              />
              <p v-if="errors.account" class="txn-field-error">{{ errors.account }}</p>
            </div>

            <div
              v-if="account.length !== 0"
              class="txn-account-panel"
            >
              <p class="txn-account-name">{{ account[0].name }}</p>
              <div class="txn-account-row">
                <span class="txn-account-row__label">{{
                  $store.state.language === 'en'
                    ? 'Account name'
                    : 'အကောင့် အမည်'
                }}</span>
                <span class="txn-account-row__value">{{ account[0].account_name }}</span>
              </div>
              <div class="txn-account-row txn-account-row--copy">
                <span class="txn-account-row__label">{{
                  $store.state.language === 'en'
                    ? 'Number'
                    : 'အကောင့် နံပါတ်'
                }}</span>
                <span id="textToCopy" class="txn-account-row__value txn-account-row__mono">{{ account[0].number }}</span>
                <button
                  type="button"
                  class="txn-copy-btn"
                  @click="copyText"
                >
                  {{ $store.state.language === 'en' ? 'Copy' : 'ကူးမည်' }}
                </button>
              </div>
            </div>

            <div class="txn-field">
              <label class="txn-label" for="deposit-amount">{{
                $store.state.language === 'en'
                  ? 'Amount'
                  : 'ငွေပမာဏ'
              }}</label>
              <span class="txn-hint">{{
                $store.state.language === 'en'
                  ? 'Minimum 2,000 MMK'
                  : 'အနည်းဆုံး 2,000 ကျပ်'
              }}</span>
              <span v-if="paymentMode === 'auto'" class="txn-hint txn-hint--auto">{{
                $store.state.language === 'en'
                  ? 'Auto deposit — transfer to the gateway account shown below'
                  : 'Auto ငွေသွင်း — အောက်ပါ gateway အကောင့်သို့ လွှဲပါ'
              }}</span>
              <input
                id="deposit-amount"
                type="number"
                class="txn-input"
                v-model="depositData.amount"
                :placeholder="$store.state.language === 'en' ? 'Amount' : 'ငွေပမာဏ'"
              >
              <p v-if="errors.amount" class="txn-field-error">{{ errors.amount }}</p>
            </div>

            <div class="txn-chip-grid">
              <span v-show="false">{{ testing }}</span>
              <button
                v-for="amt in [2000, 5000, 10000, 30000, 50000, 100000]"
                :key="amt"
                type="button"
                class="txn-chip"
                :class="{ 'txn-chip--active': depositData.amount === amt }"
                @click="depositCustomAmount(amt)"
              >
                {{ amt.toLocaleString() }} MMK
              </button>
            </div>

            <div class="txn-field">
              <label class="txn-label" for="deposit-remark">{{
                $store.state.language === 'en'
                  ? 'Last transaction ID (6 digits)'
                  : 'လုပ်ဆောင်မှုအမှတ်စဉ် (နောက်ဆုံး ၆ လုံး)'
              }}</label>
              <input
                id="deposit-remark"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                class="txn-input"
                :placeholder="$store.state.language === 'en' ? '6 digits' : '၆ လုံး'"
                v-model="depositData.remark"
                maxlength="6"
                @input="depositData.remark = (depositData.remark || '').replace(/\D/g, '').slice(0, 6)"
              >
              <p v-if="errors.remark" class="txn-field-error">{{ errors.remark }}</p>
            </div>

            <van-radio-group
              v-if="is_promotion && $store.state.disableJson?.promotions?.is_open"
              v-model="depositData.is_bonus"
              class="txn-bonus-group"
            >
              <van-radio
                class="txn-radio"
                :name="false"
                checked-color="#5c98ff"
              >
                {{ $store.state.language === 'en' ? 'No bonus' : 'ဘောနပ် မယူပါ။' }}
              </van-radio>
              <van-radio
                class="txn-radio"
                :name="true"
                checked-color="#5c98ff"
              >
                {{ $store.state.language === 'en' ? 'Claim bonus' : 'ဘောနပ် ယူမည်။' }}
              </van-radio>
            </van-radio-group>

            <button
              type="button"
              class="txn-submit"
              :disabled="isConfirm"
              @click="sendDepositData"
            >
              <Loading
                v-if="isConfirm"
                color="#ffffff"
                size="24"
                class="txn-submit__loading"
              />
              <span v-else>{{
                $store.state.language === 'en'
                  ? 'Confirm'
                  : 'အတည်ပြုမည်'
              }}</span>
            </button>
          </form>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      selected_account: {},
      accounts: [],
      account: [],
      imageUploader: [],
      depositData: {
        is_bonus: false,
      },
      is_promotion: true,
      paymentMode: 'auto',
      errors: {},
      isConfirm: false,
      testing: 0,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    depositCustomAmount(number) {
      this.depositData.amount = number;
      this.testing = number;
    },
    copyText() {
      const el = document.getElementById('textToCopy');
      if (!el) return;
      const textToCopy = el.innerText.trim();
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      Toast.success(
        this.$store.state.language === 'en'
          ? 'Copied to clipboard'
          : 'ကူးပြီးပြီ',
      );
    },
    async fetchAccounts() {
      try {
        const paymentMode = this.$store.state.disableJson?.payments?.deposit_mode || 'auto';
        this.paymentMode = paymentMode;

        const endpoint = paymentMode === 'manual' ? '/accounts' : '/gateway/payment-accounts';
        const res = await axios.get(endpoint, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.accounts = res.data.data;
        this.is_promotion = res.data.is_promotion;
        if (res.data.payment_mode) {
          this.paymentMode = res.data.payment_mode;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async sendDepositData() {
      try {
        await this.fetchUser();
        this.errors = {};
        if (!this.selected_account.account_id) {
          this.errors.account = this.$store.state.language === 'en'
            ? 'Please pick account type'
            : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
          return false;
        }
        const remark = (this.depositData.remark || '').replace(/\D/g, '');
        if (remark.length !== 6) {
          this.errors.remark = this.$store.state.language === 'en'
            ? 'Please enter last transaction id (exactly 6 digits)'
            : 'ငွေစာရင်းနောက်ဆုံးနံပါတ် ၆ လုံး အတိအကျ ထည့်ပေးပါ။';
          return false;
        }
        this.depositData.remark = remark;

        if (!this.depositData.amount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter amount'
            : 'ငွေပမာဏထည့်ပေးပါ။';
          return false;
        }
        if (this.depositData.amount < 2000) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter at least 2000 MMK'
            : 'ငွေပမာဏအနည်းဆုံး 2000 ထည့်ပေးပါ။';
          return false;
        }
        this.isConfirm = true;
        this.depositData.account_id = this.account[0].id;
        this.depositData.date = this.currentTime;

        if (this.paymentMode === 'auto') {
          this.depositData.gateway_payment_account_id = this.account[0].id;
          this.depositData.payment_method = this.account[0].payment_method || 'KPAY';
        } else {
          delete this.depositData.gateway_payment_account_id;
          delete this.depositData.payment_method;
        }

        await axios.post('/deposits', this.depositData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.depositData = { is_bonus: false };
        this.selected_account.account_id = null;
        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success'
            : 'အောင်မြင်သည်။',
        );
        this.isConfirm = false;
      } catch (error) {
        this.isConfirm = false;
        let errorMessage = 'ငွေသွင်း၍ မရသေးပါ။ Customer service သို့ဆက်သွယ်ပေးပါ။';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        Dialog.alert({
          message: errorMessage,
          confirmButtonText:
            this.$store.state.language === 'en'
              ? 'Go Back'
              : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();
      return new Date(year, month, day, hour, minute, second, millisecond);
    },
  },
  watch: {
    'selected_account.account_id': function () {
      this.account = this.accounts.filter(
        (account) => account.id === this.selected_account.account_id,
      );
    },
  },
  computed: {
    currentTime() {
      return moment(this.createDateWithTimeZone()).format('lll');
    },
  },
  async mounted() {
    this.fetchAccounts();
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
  },
};
</script>
<style scoped>
.txn-page {
  min-height: 100vh;
  padding: 1rem 0.75rem 1.25rem;
  padding-bottom: calc(1.25rem + env(safe-area-inset-bottom, 0px));
  background-color: #0d0e12;
  background-image: linear-gradient(180deg, rgba(13, 14, 18, 0.92) 0%, rgba(13, 14, 18, 0.88) 100%),
    url('https://storage.googleapis.com/spacetech2/mdl/bg.png');
  background-size: cover;
  background-position: center top;
  background-attachment: scroll;
  -webkit-overflow-scrolling: touch;
}

.txn-inner {
  margin: 0 auto;
  max-width: 32rem;
}

.txn-card {
  background: #1d1f26;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  margin-bottom: 1rem;
  overflow: hidden;
}

.txn-title {
  color: #e8eaef;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin: 0;
  padding: 0.85rem 1rem 0.35rem;
  text-transform: uppercase;
}

.txn-body {
  padding: 0.5rem 1.125rem 1.35rem;
}

.txn-field {
  margin-bottom: 1.35rem;
}

.txn-label {
  color: #8b95a8;
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.txn-hint {
  color: #5c6478;
  display: block;
  font-size: 0.8rem;
  margin: -0.1rem 0 0.5rem;
}

.txn-hint--auto {
  color: #8ab4ff;
  margin-top: 0.35rem;
}

.txn-input {
  background: #252830 !important;
  border: none !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  color: #f0f2f5 !important;
  font-size: 1rem !important;
  line-height: 1.4 !important;
  min-height: 3.35rem;
  padding: 0.9rem 1rem !important;
  width: 100%;
}

.txn-input:focus {
  box-shadow: 0 0 0 2px rgba(92, 152, 255, 0.45) !important;
  outline: none !important;
}

.txn-input::placeholder {
  color: #5c6478;
}

.txn-field-error {
  color: #ff6b7a;
  font-size: 0.8125rem;
  margin: 0.45rem 0 0;
}

.txn-account-panel {
  background: #252830;
  border-radius: 12px;
  margin-bottom: 1.15rem;
  padding: 1.1rem 1.15rem;
}

.txn-account-name {
  color: #6a9fff;
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 0.75rem;
}

.txn-account-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem 0.65rem;
  margin-bottom: 0.65rem;
  min-height: 2.5rem;
}

.txn-account-row:last-child {
  margin-bottom: 0;
}

.txn-account-row__label {
  color: #8b95a8;
  flex: 0 0 auto;
  font-size: 0.8125rem;
  font-weight: 600;
}

.txn-account-row__value {
  color: #f0f2f5;
  flex: 1;
  font-size: 0.95rem;
  font-weight: 600;
  min-width: 0;
  word-break: break-all;
}

.txn-account-row__mono {
  font-variant-numeric: tabular-nums;
}

.txn-account-row--copy {
  align-items: flex-start;
}

.txn-copy-btn {
  -webkit-tap-highlight-color: transparent;
  background: rgba(92, 152, 255, 0.2);
  border: none;
  border-radius: 10px;
  color: #8ab4ff;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  min-height: 2.65rem;
  padding: 0.5rem 0.85rem;
  transition: background 0.15s ease;
}

.txn-copy-btn:active {
  background: rgba(92, 152, 255, 0.35);
}

.txn-chip-grid {
  display: grid;
  gap: 0.65rem;
  grid-template-columns: repeat(3, 1fr);
  margin: -0.15rem 0 1.25rem;
}

.txn-chip {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: #252830;
  border: 1px solid transparent;
  border-radius: 12px;
  color: #c5cad6;
  cursor: pointer;
  display: flex;
  font-size: 0.78rem;
  font-weight: 600;
  justify-content: center;
  line-height: 1.25;
  min-height: 3rem;
  padding: 0.7rem 0.45rem;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.txn-chip--active {
  background: rgba(92, 152, 255, 0.18);
  border-color: rgba(92, 152, 255, 0.55);
  color: #b8d0ff;
}

.txn-bonus-group {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  margin-bottom: 1.15rem;
}

.txn-radio {
  color: #e8eaef !important;
  font-size: 0.9375rem;
  padding: 0.35rem 0 !important;
}

.txn-submit {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: linear-gradient(180deg, #6a9fff 0%, #5c98ff 100%);
  border: none;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  font-weight: 600;
  justify-content: center;
  min-height: 3.35rem;
  padding: 0.8rem 1rem;
  transition: filter 0.15s ease;
  width: 100%;
}

.txn-submit:disabled {
  cursor: wait;
  opacity: 0.85;
}

.txn-submit:not(:disabled):active {
  filter: brightness(1.05);
}

.txn-submit__loading {
  padding: 0 !important;
}

@media (max-width: 360px) {
  .txn-chip-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
